import React from "react";
import "./MinhasMetas.css";

const formatarMoeda = (valor) => {
  const numero = typeof valor === "string"
    ? Number(valor.replace(/\./g, "").replace(",", "."))
    : typeof valor === "number"
      ? valor
      : 0;

  if (isNaN(numero)) return "R$ 0,00";

  return numero.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const parseMoeda = (valor) => {
  if (!valor) return 0;
  if (typeof valor === "number") return valor;

  const numero = Number(valor.replace(/\./g, "").replace(",", "."));
  return isNaN(numero) ? 0 : numero;
};


const MinhasMetas = ({
  metaMensal,
  clientesCarteira,
  ticketMedio,
  metaTrimestralAtual,
  metaTrimestralTotal,
  dataAtualizacao,
}) => {
  const percentual = (() => {
    const atual = parseMoeda(metaTrimestralAtual);
    const total = parseMoeda(metaTrimestralTotal);

    if (total === 0) return 0;

    return Math.min(100, Math.round((atual / total) * 100));
  })();

  return (
    <div className="container my-4">
      <div className="row">
        <div className="col-md-12">
          <h3 className="card-title text-dark font-weight-bold mb-4">Minhas Metas</h3>

          <div className="form-group">
            <label>Meta de vendas (R$ - mensal):</label>
            <input
              type="text"
              className="form-control"
              value={formatarMoeda(metaMensal)}
              readOnly
            />
          </div>

          <div className="form-group">
            <label>Quantidade de clientes na carteira:</label>
            <input
              type="text"
              className="form-control"
              value={`${clientesCarteira} clientes`}
              readOnly
            />
          </div>

          <div className="form-group">
            <label>Ticket médio (R$):</label>
            <input
              type="text"
              className="form-control"
              value={formatarMoeda(ticketMedio)}
              readOnly
            />
          </div>

          <div className="form-group">
            <label>Meta Trimestral (% alcançado):</label>
            <div className="minhas-metas-progress mb-1">
              <div
                className="minhas-metas-progress-bar"
                role="progressbar"
                style={{ width: `${percentual}%` }}
                aria-valuenow={percentual}
                aria-valuemin="0"
                aria-valuemax="100"
              >
                {percentual}%
              </div>
            </div>
            <small className="text-muted">
              {formatarMoeda(metaTrimestralAtual)} de {formatarMoeda(metaTrimestralTotal)} (
              {percentual}%)
            </small>
          </div>

          <div className="d-flex align-items-center mt-3 text-muted">
            <i className="fas fa-clock mr-2 text-warning"></i>
            <small>Atualizado em: {dataAtualizacao}</small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MinhasMetas;
